import {
  calculateColumnWidth,
  mapColumnTypes,
  TYPES,
} from "@/react/components/table/columns";
import selectColumnFactory from "@/react/components/table/components/selectColumnFactory";
import { getColumnDef } from "@/react/schema/schemaFields";
import schema from "./schema";
import { EMAIL_CHANNEL_PROTOCOLS } from "./constants";

const columnDefinition = () =>
  calculateColumnWidth(
    [
      selectColumnFactory(),
      { ...getColumnDef(schema.fields.id, "ID"), type: TYPES.ID },
      {
        ...getColumnDef(schema.fields.name, "Name"),
        customCell: ({ getValue }) => <strong>{getValue()}</strong>,
        editable: true,
        sticky: true,
      },
      {
        ...getColumnDef(schema.fields.is_enabled, "Enabled"),
        editable: true,
        type: TYPES.BOOLEAN,
      },
      {
        ...getColumnDef(schema.fields.email_address, "Email Address"),
        editable: true,
      },
      {
        ...getColumnDef(schema.fields.script_id, "Script ID"),
        editable: true,
      },
      {
        ...getColumnDef(
          schema.fields.incoming_mail_server,
          "Incoming Mail Server"
        ),
        editable: true,
      },
      {
        ...getColumnDef(schema.fields.protocol, "Protocol"),
        editable: true,
        type: TYPES.SELECT,
        options: Object.fromEntries(
          EMAIL_CHANNEL_PROTOCOLS.map((emailChannelProtocol) => [
            emailChannelProtocol,
            emailChannelProtocol,
          ])
        ),
      },
      {
        ...getColumnDef(schema.fields.port, "Port"),
        editable: true,
        type: TYPES.NUMBER,
      },
      {
        ...getColumnDef(
          schema.fields.incoming_mail_user_id,
          "Incoming Mail User ID"
        ),
        editable: true,
      },
      {
        ...getColumnDef(
          schema.fields.incoming_mail_password,
          "Incoming Mail User Password"
        ),
        editable: true,
      },
      {
        ...getColumnDef(
          schema.fields.outgoing_mail_server,
          "Outgoing Mail Server"
        ),
        editable: true,
      },
      {
        ...getColumnDef(
          schema.fields.outgoing_smtp_server_user_id,
          "Outgoing SMTP Server User ID"
        ),
        editable: true,
      },
      {
        ...getColumnDef(
          schema.fields.outgoing_alternative_credential_enabled,
          "Outgoing Alternative Credential"
        ),
        editable: true,
        type: TYPES.BOOLEAN,
      },
      {
        ...getColumnDef(schema.fields.is_oauth_enabled, "OAuth"),
        editable: true,
        type: TYPES.BOOLEAN,
      },
    ].map(mapColumnTypes)
  );

export default columnDefinition;
